/**
 * Подбор шрифтового стека под то, что реально лежит в /fonts.
 *
 * Если сослаться на отсутствующее семейство, MapLibre не нарисует вообще ни
 * одной подписи и не скажет об этом ничего внятного. Поэтому имя семейства
 * берётся из манифеста, а не из константы в коде.
 */

const PREFERRED_REGULAR = ["Noto Sans Regular", "Open Sans Regular", "Roboto Regular"];
const PREFERRED_BOLD = ["Noto Sans Bold", "Open Sans Bold", "Roboto Bold"];

function pick(available: string[], preferred: string[], fallbackMatch: RegExp): string[] {
  for (const candidate of preferred) {
    if (available.includes(candidate)) return [candidate];
  }
  const loose = available.find((family) => fallbackMatch.test(family));
  if (loose) return [loose];
  return available.length > 0 ? [available[0] as string] : [];
}

export interface FontStacks {
  regular: string[];
  bold: string[];
}

export function resolveFonts(available: string[]): FontStacks {
  return {
    regular: pick(available, PREFERRED_REGULAR, /regular|book|normal/i),
    bold: pick(available, PREFERRED_BOLD, /bold|semibold|medium/i),
  };
}
